import basePageFields from '@fragments/pages/basePageFields';

import StreamTierFullBleedFragment from '@fragments/shared/StreamTierFullBleedFragment';
import StreamTierW100Fragment from '@fragments/shared/StreamTierW100Fragment';
import StreamTierW5050Fragment from '@fragments/shared/StreamTierW5050Fragment';
import StreamTierW502525Fragment from '@fragments/shared/StreamTierW502525Fragment';
import StreamTierW252550Fragment from '@fragments/shared/StreamTierW252550Fragment';
import StreamTierW333333Fragment from '@fragments/shared/StreamTierW333333Fragment';
import StreamTierW25252525Fragment from '@fragments/shared/StreamTierW25252525Fragment';
import VideoPosterFragment from '@fragments/shared/VideoPosterFragment';
import TagFragment from '@fragments/pages/TagFragment';
import ImageSummaryFragment from '@fragments/summaries/ImageSummaryFragment';
import PersonSummaryFragment from '@fragments/summaries/PersonSummaryFragment';
import StreamContainedFragment from '@fragments/shared/StreamContainedFragment';
import SyndicationsFragment from '@fragments/shared/SyndicationsFragment';
import SeoFragment from '@fragments/shared/SeoFragment';
import FileFragment from '@fragments/shared/FileFragment';

export default gql`
    fragment EventFragment on Event {
        ${basePageFields}
        dek
        listDisplayFormat
        subtype
        attendanceType

        hero {
            image {
                ...ImageSummaryFragment
            }
        }
        video {
            ...VideoPosterFragment
        }

        eventRSVP {
            url
            type
        }

        eventDate {
            start
            end
            timeZone
            startTimestamp
            endTimestamp
        }
        eventLocation
        primaryContact {
            ...PersonSummaryFragment
        }

        marketoCampaign {
            id
            formId
            enabled
        }

        supplementalLinks {
            link {
                url
                label
                type
                newTab
                reference {
                    path
                }
                file {
                    ...FileFragment
                }
            }
        }

        contributors {
            ...PersonSummaryFragment
        }
        displaySpeakers

        streamTiered {
            ...StreamTierFullBleedFragment
            ...StreamTierW100Fragment
            ...StreamTierW5050Fragment
            ...StreamTierW502525Fragment
            ...StreamTierW252550Fragment
            ...StreamTierW333333Fragment
            ...StreamTierW25252525Fragment
        }

        streamContained {
            ...StreamContainedFragment
        }

        tags {
            ...TagFragment
        }
        syndications {
            ...SyndicationsFragment
        }
        seo {
            ...SeoFragment
        }
    }

    ${TagFragment}
    ${FileFragment}
    ${StreamTierFullBleedFragment}
    ${StreamTierW100Fragment}
    ${StreamTierW5050Fragment}
    ${StreamTierW502525Fragment}
    ${StreamTierW252550Fragment}
    ${StreamTierW333333Fragment}
    ${StreamTierW25252525Fragment}
    ${VideoPosterFragment}
    ${ImageSummaryFragment}
    ${PersonSummaryFragment}
    ${StreamContainedFragment}
    ${SyndicationsFragment}
    ${SeoFragment}
`;
